import { useQueryClient } from '@tanstack/react-query';
import { authApi } from '../api/auth';
import { useAuth } from '../hooks/useAuth';
import ContentApprovalsBadge from './ContentApprovalsBadge';
import ContextPicker from './ContextPicker';
import { showToast } from './Toast';
import { APP_VERSION } from '../lib/version';
import type { ContextView } from '../types';

type Props = {
  view: ContextView;
  onChangeView: (view: ContextView) => void;
};

export default function Header({ view, onChangeView }: Props) {
  const { user } = useAuth();
  const queryClient = useQueryClient();

  async function handleLogout() {
    try {
      await authApi.logout();
      queryClient.clear();
      window.location.assign('/login');
    } catch (err) {
      showToast(`Logout failed: ${(err as Error).message}`, { variant: 'error' });
    }
  }

  return (
    <header className="app-header">
      <div className="app-header-inner">
        <div className="brand">
          <strong>Marketing Dashboard</strong>
          <span className="brand-version">v. {APP_VERSION}</span>
        </div>
        <div className="header-right">
          <ContextPicker view={view} onChange={onChangeView} />
          <ContentApprovalsBadge />
          {user && (
            <div className="user-menu">
              <span className="user-name" title={user.email}>
                {user.name ?? user.email}
                <span className="user-role">{user.role}</span>
              </span>
              <button type="button" className="logout-btn" onClick={handleLogout}>
                Sign out
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
